import type { PropsWithChildren } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { Toaster } from "@/shared/ui/sonner";
import { UppyProvider } from "./UppyProvider";
import { MsalProvider } from "./MsalProvider";

export type AppProvidersProps = PropsWithChildren<{
  queryClient: QueryClient;
}>;

export function AppProviders({ children, queryClient }: AppProvidersProps) {
  return (
    <MsalProvider>
      <QueryClientProvider client={queryClient}>
        <UppyProvider>
          {children}
          <Toaster />
          {import.meta.env.DEV ? (
            <ReactQueryDevtools buttonPosition="bottom-left" />
          ) : null}
        </UppyProvider>
      </QueryClientProvider>
    </MsalProvider>
  );
}
